import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class MessageClaraDraftSourceLocator extends BaseModel {
  label?: string | null;
  recordId?: string | null;
  tab?: string | null;
  section?: string | null;
  conversationId?: string | null;
  url?: string | null;

  constructor(model: Partial<MessageClaraDraftSourceLocator> = {}) {
    super(model);

    this.label = model.label;
    this.recordId = model.recordId;
    this.tab = model.tab;
    this.section = model.section;
    this.conversationId = model.conversationId;
    this.url = model.url;
  }
}
